<template>
  <el-container>
    <el-header>
      <el-form
        size="small"
        :inline="true"
        :model="form"
        :label-position="labelPosition"
        :label-width="labelWidth"
        @submit.native.prevent
      >
        <el-form-item label="所用字符">
          <el-checkbox-group v-model="form.chars">
            <el-checkbox label="number" name="chars">0-9</el-checkbox>
            <el-checkbox label="lowercase" name="chars">a-z</el-checkbox>
            <el-checkbox label="uppercase" name="chars">A-Z</el-checkbox>
            <el-checkbox label="specialchars" name="chars">特殊字符</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="密码长度">
          <el-input-number v-model="form.length" controls-position="right" :min="1" :max="10000"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="genRandomCipher">生成</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-main>
      <el-input type="textarea" :autosize="autosize" v-model="form.result"></el-input>
    </el-main>
  </el-container>
</template>

<script>
import { numbers, lowercase, uppercase, specialchars } from "@/utils.js";

export default {
  name: "RandomCipher",
  data() {
    return {
      form: this.initform
    };
  },
  props: {
    labelPosition: {
      type: String,
      default: "left"
    },
    labelWidth: {
      type: String,
      default: "auto"
    },
    autosize: {
      type: Object,
      // ({ minRows: 5, maxRows: 35 }) equal {return { minRows: 5, maxRows: 35 }}      
      default: () => ({ minRows: 5, maxRows: 35 })
    },
    initform: {
      type: Object,
      default: () => ({
        chars: ["number", "lowercase", "uppercase"],
        length: 8,
        result: ""
      })
    }
  },
  methods: {
    genRandomCipher: function() {
      let s = "";
      let cipher = "";
      if (this.form.chars.indexOf("number") !== -1) {
        s += numbers;
      }
      if (this.form.chars.indexOf("lowercase") !== -1) {
        s += lowercase;
      }
      if (this.form.chars.indexOf("uppercase") !== -1) {
        s += uppercase;
      }
      if (this.form.chars.indexOf("specialchars") !== -1) {
        s += specialchars;
      }
      for (let i = 0; i < this.form.length; i++) {
        cipher += s.charAt(Math.floor(Math.random() * s.length));
      }
      this.form.result = cipher;
    }
  }
};
</script>
